import React, { useState } from 'react';
import { MTBFChart, AverageProductionSpeedChart } from '../charts';
import SubTabNav from '../common/SubTabNav';

interface MTBFChartContainerProps {
  machineSerialNo?: string;
  lineId?: string; // Line ID for line-level aggregated data
  shifts?: string[];
  syncGroup?: string;
  activeSubTab?: 'mtbf' | 'speed';
  onActiveSubTabChange?: (tab: 'mtbf' | 'speed') => void;
}

const MTBFChartContainer: React.FC<MTBFChartContainerProps> = ({ 
  machineSerialNo, 
  lineId,
  shifts, 
  syncGroup, 
  activeSubTab: externalActiveSubTab,
  onActiveSubTabChange 
}) => {
  const [internalActiveSubTab, setInternalActiveSubTab] = useState<'mtbf' | 'speed'>('mtbf');
  
  // Use external activeSubTab if provided, otherwise use internal state
  const activeSubTab = externalActiveSubTab ?? internalActiveSubTab;
  
  const setActiveSubTab = (tab: 'mtbf' | 'speed') => {
    if (onActiveSubTabChange) {
      onActiveSubTabChange(tab);
    } else {
      setInternalActiveSubTab(tab);
    }
  };

  // Suppress unused syncGroup warning
  React.useEffect(() => { void syncGroup; }, [syncGroup]);

  const renderChart = () => {
    switch (activeSubTab) {
      case 'mtbf':
        return (
          <MTBFChart
            machineSerialNo={machineSerialNo}
            lineId={lineId}
            shifts={shifts}
            className="w-full"
          />
        );
      case 'speed':
        return (
          <AverageProductionSpeedChart
            machineSerialNo={machineSerialNo}
            lineId={lineId}
            shifts={shifts}
            className="w-full"
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="space-y-4">
      {/* Subtab navigation */}
      <SubTabNav
        tabs={[
          { key: 'mtbf', label: 'MTBF Analysis' },
          { key: 'speed', label: 'Average Production Speed' }
        ]}
        activeTab={activeSubTab}
        onTabChange={(tab) => setActiveSubTab(tab as 'mtbf' | 'speed')}
      />

      {/* Chart content */}
      {renderChart()}
    </div>
  );
};

export default MTBFChartContainer;
